<div class="title title--big">Справочники</div>

<div class="grid mt-32">
  <div class="grid__box grid__box--size-8">
    <div class="main-tiles">
      <app-role-access [action]="'visible'" [permission]="'employee.get'">
        <div class="main-tiles__item">
          <a class="main-tiles__item-link" routerLink="{{ '/' + USERS_PATHS.users }}" target="_blank">
            <div class="item__header">
              <app-icon [glyph]="'user-main'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Сотрудники</div>
          </a>
        </div>
      </app-role-access>
      <app-role-access [action]="'visible'" [permission]="'partnership.get'">
        <div class="main-tiles__item">
          <a class="main-tiles__item-link" routerLink="{{ '/' + COMPANIES_PATHS.companies }}" target="_blank">
            <div class="item__header">
              <app-icon [glyph]="'company'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Компании</div>
          </a>
        </div>
      </app-role-access>
      <app-role-access [action]="'visible'" [permission]="'sector.get'">
        <div class="main-tiles__item">
          <a class="main-tiles__item-link" routerLink="{{ '/' + SECTORS_PATHS.sectors }}" target="_blank">
            <div class="item__header">
              <app-icon [glyph]="'sect'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Участки</div>
          </a>
        </div>
      </app-role-access>
      <app-role-access [action]="'visible'" [permission]="'normatives.get'">
        <div class="main-tiles__item">
          <a class="main-tiles__item-link" routerLink="{{ '/' + NORMATIVES_PATHS.normatives }}" target="_blank">
            <div class="item__header">
              <app-icon [glyph]="'list'" [size]="'48'" [color]="'gray-dark'"></app-icon>
            </div>
            <div class="item__content">Нормативы</div>
          </a>
        </div>
      </app-role-access>
      <div class="main-tiles__item">
        <a class="main-tiles__item-link" routerLink="{{ '/' + USERS_PATHS.service_functions }}" target="_blank">
          <div class="item__header">
            <app-icon [glyph]="'func'" [size]="'48'" [color]="'gray-dark'"></app-icon>
          </div>
          <div class="item__content">Функции</div>
        </a>
      </div>
    </div>
  </div>
</div>
